/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CriteriaForAgencyGroupOutput,
    CriteriaForAgencyGroupOutputFromJSON,
    CriteriaForAgencyGroupOutputFromJSONTyped,
    CriteriaForAgencyGroupOutputToJSON,
    CriteriaForAgencyOutput,
    CriteriaForAgencyOutputFromJSON,
    CriteriaForAgencyOutputFromJSONTyped,
    CriteriaForAgencyOutputToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface SystemContextOutput
 */
export interface SystemContextOutput {
    /**
     * 
     * @type {Array<CriteriaForAgencyOutput>}
     * @memberof SystemContextOutput
     */
    agencies?: Array<CriteriaForAgencyOutput> | null;
    /**
     * 
     * @type {Array<CriteriaForAgencyGroupOutput>}
     * @memberof SystemContextOutput
     */
    agencyGroups?: Array<CriteriaForAgencyGroupOutput> | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof SystemContextOutput
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof SystemContextOutput
     */
    channels?: Array<Int32IdAndLabel> | null;
}

export function SystemContextOutputFromJSON(json: any): SystemContextOutput {
    return SystemContextOutputFromJSONTyped(json, false);
}

export function SystemContextOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemContextOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'agencies': !exists(json, 'agencies') ? undefined : (json['agencies'] === null ? null : (json['agencies'] as Array<any>).map(CriteriaForAgencyOutputFromJSON)),
        'agencyGroups': !exists(json, 'agencyGroups') ? undefined : (json['agencyGroups'] === null ? null : (json['agencyGroups'] as Array<any>).map(CriteriaForAgencyGroupOutputFromJSON)),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'channels': !exists(json, 'channels') ? undefined : (json['channels'] === null ? null : (json['channels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
    };
}

export function SystemContextOutputToJSON(value?: SystemContextOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'agencies': value.agencies === undefined ? undefined : (value.agencies === null ? null : (value.agencies as Array<any>).map(CriteriaForAgencyOutputToJSON)),
        'agencyGroups': value.agencyGroups === undefined ? undefined : (value.agencyGroups === null ? null : (value.agencyGroups as Array<any>).map(CriteriaForAgencyGroupOutputToJSON)),
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'channels': value.channels === undefined ? undefined : (value.channels === null ? null : (value.channels as Array<any>).map(Int32IdAndLabelToJSON)),
    };
}


